import React from 'react';
import "./Footer.css"

const Footer = () => {

	/*<img className='img' src="https://i.pinimg.com/originals/2c/64/8d/2c648daf40c9cfbc2fa61ba776f5ba46.gif" alt="" />
				<img  className='img' src="https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/f/e0a92ea1-70ed-4a32-a82c-f119ffa02312/d4vxz6d-a0eda804-a31a-491f-8367-b960e61c61fb.gif?token=eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7InBhdGgiOiJcL2ZcL2UwYTkyZWExLTcwZWQtNGEzMi1hODJjLWYxMTlmZmEwMjMxMlwvZDR2eHo2ZC1hMGVkYTgwNC1hMzFhLTQ5MWYtODM2Ny1iOTYwZTYxYzYxZmIuZ2lmIn1dXSwiYXVkIjpbInVybjpzZXJ2aWNlOmZpbGUuZG93bmxvYWQiXX0.e5zzTmO5gPZYwke2EbesT4J7YyCDmTbG097V5oydjGQ" alt="" />*/

	return (
		<footer className="footer">
		
			<div>

				<img className='img' src="https://i.pinimg.com/originals/ab/be/28/abbe28a943ed44fcd98452687f7c46c9.gif" alt="" />

				<span >Jair Rincon</span>
			
				<img className='img' src="https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/f/3df4c99b-cd18-428c-ae79-9e4f10e97c81/d7a2fba-610c77f6-9ef2-4573-9930-29cf60592f44.gif?token=eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7InBhdGgiOiJcL2ZcLzNkZjRjOTliLWNkMTgtNDI4Yy1hZTc5LTllNGYxMGU5N2M4MVwvZDdhMmZiYS02MTBjNzdmNi05ZWYyLTQ1NzMtOTkzMC0yOWNmNjA1OTJmNDQuZ2lmIn1dXSwiYXVkIjpbInVybjpzZXJ2aWNlOmZpbGUuZG93bmxvYWQiXX0.Cb5s1jfx_q20G8dlaBwd47ZqxorHR4jKUhQpc1qmQy4" alt="" />

				
			</div>
							
					
		</footer>
	);
};

export default Footer;
